'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$73() {
  this.blN = null;
  this.blO = false;
}
export { $c_Lpresto_PrestoRouter$$anon$73 as $c_Lpresto_PrestoRouter$$anon$73 };
$p = $c_Lpresto_PrestoRouter$$anon$73.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$73;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$73() {
}
export { $h_Lpresto_PrestoRouter$$anon$73 as $h_Lpresto_PrestoRouter$$anon$73 };
$h_Lpresto_PrestoRouter$$anon$73.prototype = $p;
$p.P = (function() {
  if ((!this.blO)) {
    this.blN = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.blO = true;
  }
  return this.blN;
});
var $d_Lpresto_PrestoRouter$$anon$73 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$73, "presto.PrestoRouter$$anon$73", ({
  OQ: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$73 as $d_Lpresto_PrestoRouter$$anon$73 };
//# sourceMappingURL=presto.-Presto-Router$$anon$73.js.map
